import { FormAccordion } from '@strata/react-form-section';
import { useEffect, useRef } from 'react';

/** Focus input on active section open */
export const useInputFocusRef = (isOpen, activeSection, section) => {
    const inputRef = useRef(null);
    useEffect(() => {
        if (isOpen && activeSection === section) {
            // Need to set timeout when focusing on accordion section open
            setTimeout(() => inputRef.current?.focus(), FormAccordion.AnimateDuration);
        }
    }, [isOpen, activeSection, section]);
    return inputRef;
};

/** Reset form when section is opened */
export const useFormResetRef = (isOpen) => {
    const formRef = useRef(null);
    useEffect(() => {
        if (isOpen) {
            formRef.current?.handleReset();
        }
    }, [isOpen]);
    return formRef;
};
